import pageboxLogo from "../../assets/pagebox/logo.webp";
import { useState } from "react";
import "./PageboxQrComplete.css";

/** Phone-browser completion: no native bridge or unreliable window.close(). */
export function PageboxQrComplete({ password = false, username }: { password?: boolean; username?: string }) {
    const [copyState, setCopyState] = useState("");
    async function copyUsername() {
        if (!username) return;
        try {
            await navigator.clipboard.writeText(username);
            setCopyState("아이디를 복사했어요.");
        } catch {
            setCopyState("아이디를 길게 눌러 복사해주세요.");
        }
    }
    if (!password) return <main className="pb-qr-complete">
        <div className="pb-qr-complete__brand"><img src={pageboxLogo} alt="페이지박스" /><span>PAGEBOX</span></div>
        <section className="pb-qr-complete__card" aria-labelledby="pb-qr-title">
            <div className="pb-qr-complete__check" aria-hidden="true">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none"><path d="m5 12 4 4L19 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </div>
            <p className="pb-qr-complete__eyebrow">회원가입 완료</p>
            <h1 id="pb-qr-title">가입을 환영해요!</h1>
            <p className="pb-qr-complete__intro">페이지박스와 함께<br />새로운 이야기를 만나보세요.</p>
            {username && <div className="pb-qr-complete__identity">
                <span>내 페이지박스 아이디</span>
                <strong>{username}</strong>
                <button type="button" onClick={copyUsername}>
                    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="8" y="8" width="12" height="13" rx="2" stroke="currentColor" strokeWidth="1.6" /><path d="M15 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" stroke="currentColor" strokeWidth="1.6" /></svg>
                    아이디 복사
                </button>
                <p className="pb-qr-complete__copy-status" role="status">{copyState}</p>
            </div>}
            <div className="pb-qr-complete__next">
                <span className="pb-qr-complete__device" aria-hidden="true">
                    <svg width="25" height="32" viewBox="0 0 25 32" fill="none"><rect x="2" y="1" width="21" height="29" rx="3" stroke="currentColor" strokeWidth="1.6" /><path d="M6 6h13M6 10h13M6 14h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /><circle cx="12.5" cy="25" r="1" fill="currentColor" /></svg>
                </span>
                <div><h2>이제 기기에서 로그인해주세요</h2><p>페이지박스 기기에서 방금 가입한<br />아이디와 비밀번호를 입력해주세요.</p></div>
            </div>
        </section>
        <p className="pb-qr-complete__footer">가입이 완료되었으니 이 창은 닫으셔도 됩니다.</p>
    </main>;
    return <main style={{ maxWidth: 640, margin: "0 auto", padding: "64px 24px", boxSizing: "border-box", color: "#111", lineHeight: 1.8, textAlign: "center", wordBreak: "keep-all", overflowWrap: "break-word" }}>
        <div aria-hidden="true" style={{ width: 56, height: 56, margin: "0 auto 20px", borderRadius: "50%", background: "#f1f3f5", display: "grid", placeItems: "center", fontSize: 30 }}>✓</div>
        <h1 style={{ fontSize: 24, margin: "0 0 24px" }}>{password ? "비밀번호 변경 완료" : "회원가입이 완료되었습니다!"}</h1>
        <div role="status" style={{ fontSize: 18 }}>
            <p>비밀번호가 변경되었습니다.</p>
            <p>페이지박스 기기에서 새 비밀번호로 로그인해주세요.</p>
            <p style={{ marginTop: 32, fontSize: 16, color: "#555" }}>이 창은 닫으셔도 됩니다.</p>
        </div>
    </main>;
}
